import { mediaUrl } from '@/config';

export default media => {
    if (!media) {
        return;
    }

    const { type, date, filename, extension } = media;

    return `${mediaUrl}/${type}s/${date}/${filename}.${extension}`;
};
